import { Routes } from '@angular/router';
import { attendeeAuthGuard } from 'src/app/@core/auth/guards/attendee-auth-guard';
import { loginRedirectGuard } from 'src/app/@core/auth/guards/login-redirect-guard';
import { determineSessionRegistrationId } from 'src/app/@guards/determine-session-badge-id';
import { determineSessionStatusResolver } from 'src/app/@guards/determine-session-status.resolver';

const attendeeGuard = { canActivate: [attendeeAuthGuard] };

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./@core/auth/components/login/login.component').then(
        (c) => c.LoginComponent
      ),
    canActivate: [loginRedirectGuard],
  },
  {
    path: 'otp',
    loadComponent: () =>
      import('./@core/auth/components/otp/otp.component').then(
        (c) => c.OtpComponent
      ),
    canActivate: [loginRedirectGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('./@pages/home/home.component').then((c) => c.HomeComponent),
    ...attendeeGuard,
  },
  {
    path: 'primary-screen',
    loadComponent: () =>
      import(
        './@pages/primary-event-projected-screens/primary-event-projected-screens.component'
      ).then((c) => c.PrimaryEventProjectedScreensComponent),
  },
  {
    path: 'event-agenda',
    loadComponent: () =>
      import('./@pages/event-agenda/event-agenda.component').then(
        (c) => c.EventAgendaComponent
      ),
    ...attendeeGuard,
  },
  {
    path: 'agenda',
    loadComponent: () =>
      import('./@pages/agenda/agenda-schedule.component').then(
        (c) => c.AgendaScheduleComponent
      ),
    ...attendeeGuard,
  },
  {
    path: 'exhibitors',
    loadComponent: () =>
      import('./@pages/exhibitors/exhibitors.component').then(
        (c) => c.ExhibitorsComponent
      ),
    ...attendeeGuard,
  },
  {
    path: 'network',
    loadComponent: () =>
      import('./@pages/network/network.component').then(
        (c) => c.NetworkComponent
      ),
    ...attendeeGuard,
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./@pages/profile/profile.component').then(
        (c) => c.ProfileComponent
      ),
    ...attendeeGuard,
  },
  {
    path: 'profile/preferences',
    loadComponent: () =>
      import('./@pages/profile/preferences-chat.component').then(
        (c) => c.PreferencesChatComponent
      ),
    ...attendeeGuard,
  },
  {
    path: 'exhibitor-profile',
    loadComponent: () =>
      import('./@networking/exhibitor-detail.component').then(
        (c) => c.ExhibitorDetailComponent
      ),
    ...attendeeGuard,
  },
  {
    path: 'daily-debrief/:day',
    loadComponent: () =>
      import('./@pages/event-daily-debrief/event-daily-debrief.component').then(
        (c) => c.EventDailyDebriefComponent
      ),
    ...attendeeGuard,
  },
  {
    path: 'track-trends/:track',
    loadComponent: () =>
      import('./@pages/event-track-trends/event-track-trends.component').then(
        (c) => c.EventTrackTrendsComponent
      ),
    ...attendeeGuard,
  },
  {
    path: 'session/:sessionId',
    loadComponent: () =>
      import('./@pages/session-insights/session-insights.component').then(
        (c) => c.SessionInsightsComponent
      ),
    resolve: { sessionState: determineSessionStatusResolver },
    ...attendeeGuard,
  },
  {
    path: 'session/:sessionId/live-replay',
    loadComponent: () =>
      import('./@pages/session-live-replay/session-live-replay.component').then(
        (c) => c.SessionLiveReplayComponent
      ),
    ...attendeeGuard,
  },
  {
    path: 'session/:sessionId/debrief',
    loadComponent: () =>
      import('./@pages/session-debrief/session-debrief.component').then(
        (c) => c.SessionDebriefComponent
      ),
    ...attendeeGuard,
  },
  {
    path: 'session/:sessionId/primary-debrief',
    loadComponent: () =>
      import(
        './@pages/primary-session-debrief/primary-session-debrief.component'
      ).then((c) => c.PrimarySessionDebriefComponent),
  },
  {
    path: 'session/:sessionId/:registrationId',
    loadComponent: () =>
      import(
        './@pages/session-insights-intermediate/session-insights-intermediate.component'
      ).then((c) => c.SessionInsightsIntermediateComponent),
    resolve: { sessionState: determineSessionRegistrationId },
    ...attendeeGuard,
  },
  // TODO: @later if this route is not in use then remove it
  {
    path: 'trends/:sessionId',
    loadComponent: () =>
      import('./@pages/event-track-trends/event-track-trends.component').then(
        (c) => c.EventTrackTrendsComponent
      ),
    ...attendeeGuard,
  },
  { path: '**', redirectTo: '' },
];
